import { render } from "./RemoveFromTimelineBtn.vue?vue&type=template&id=156d2628&ts=true"
import script from "./RemoveFromTimelineBtn.vue?vue&type=script&lang=ts"
export * from "./RemoveFromTimelineBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__